var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79857 10.9315H2.46053C1.25176 10.9315 0.271606 9.9513 0.271606 8.74253C0.271606 7.53376 1.25176 6.55444 2.46053 6.55444H7.7994C9.00817 6.55444 9.9875 7.53459 9.9875 8.74253C9.9875 9.9513 9.00734 10.9315 7.79857 10.9315Z",
    fill: "#383087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58691 14.1686V2.54561C5.58691 1.33684 6.56707 0.356689 7.77501 0.356689C8.98294 0.356689 9.96393 1.33684 9.96393 2.54561V14.1686C9.96393 15.3774 8.98378 16.3575 7.77501 16.3575C6.56623 16.3575 5.58691 15.3774 5.58691 14.1686Z",
    fill: "#383087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4453 8.73982C15.4453 9.93695 14.4752 10.9071 13.278 10.9071C12.0809 10.9071 11.1107 9.93695 11.1107 8.73982C11.1107 7.54269 12.0809 6.57251 13.278 6.57251C14.4752 6.57251 15.4453 7.54269 15.4453 8.73982Z",
    fill: "#383087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1736,
    height: 16,
    fill: "white",
    transform: "translate(0.271606 0.356689)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.3283b359948530775a338fee6904430d.svg";
export { ForwardRef as ReactComponent };